import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './app/global.css';
import { installTestHooks } from './app/testHooks';
import { registerServiceWorker } from './app/swUpdate';

if (import.meta.env.DEV) installTestHooks();

// PWA (§11 M11): production only. The service worker precaches the app for offline use and adds the
// COOP/COEP headers (the coi-serviceworker pattern); see app/swUpdate.ts for the reload rules.
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
